var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pp-wallet-address",attrs:{"data-test":("address-" + _vm.value)},domProps:{"textContent":_vm._s(_vm.formattedAddress)}})}
var staticRenderFns = []

export { render, staticRenderFns }